module.exports = __webpack_public_path__ + "img/DK10349818.52738526.png";